/*
 * Cart-drawer upsells — horizontal carousel nav arrows.
 *
 * The cart drawer re-renders its whole inner DOM on every cart change, so this
 * uses event delegation + a MutationObserver to (re)sync arrow visibility
 * whenever an upsells track appears or scrolls. RTL-aware: scrollLeft is
 * normalised so 0 = start regardless of direction.
 */

function normalizedScroll(track) {
  const dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
  return { dir, pos: track.scrollLeft * dir, max: track.scrollWidth - track.clientWidth };
}

function updateNavState(track) {
  const root = track.closest('.c-cart-upsells');
  if (!root) return;

  const prev = root.querySelector('[data-c-cu-nav="prev"]');
  const next = root.querySelector('[data-c-cu-nav="next"]');
  const { pos, max } = normalizedScroll(track);
  const overflowing = max > 2;

  prev?.toggleAttribute('hidden', !overflowing || pos <= 1);
  next?.toggleAttribute('hidden', !overflowing || pos >= max - 1);
}

function syncAll() {
  document.querySelectorAll('[data-c-cu-track]').forEach(updateNavState);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-c-cu-nav]');
  if (!button) return;

  const track = button.closest('.c-cart-upsells')?.querySelector('[data-c-cu-track]');
  if (!track) return;

  const dir = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
  const amount = track.clientWidth * 0.8;
  const delta = (button.dataset.cCuNav === 'prev' ? -1 : 1) * dir * amount;
  track.scrollBy({ left: delta, behavior: 'smooth' });
});

/* Mobile full-card tap: blur so :focus-within doesn't leave the quick-add chrome visible. */
document.addEventListener(
  'click',
  (event) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const btn = event.target.closest('.c-cart-upsells .quick-add__button');
    if (!btn) return;
    queueMicrotask(() => btn.blur());
  },
  true
);

document.addEventListener(
  'scroll',
  (event) => {
    const track = event.target instanceof Element ? event.target.closest?.('[data-c-cu-track]') : null;
    if (track) updateNavState(track);
  },
  true
);

if ('MutationObserver' in window) {
  const observer = new MutationObserver(() => requestAnimationFrame(syncAll));
  observer.observe(document.documentElement, { childList: true, subtree: true });
}

window.addEventListener('resize', syncAll);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncAll, { once: true });
} else {
  syncAll();
}
